
      import API from "!../../../../../.yarn/__virtual__/style-loader-virtual-1acf154a53/0/cache/style-loader-npm-3.3.4-e2ff5c12be-8f8027fc5c.zip/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../../.yarn/__virtual__/style-loader-virtual-1acf154a53/0/cache/style-loader-npm-3.3.4-e2ff5c12be-8f8027fc5c.zip/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../../.yarn/__virtual__/style-loader-virtual-1acf154a53/0/cache/style-loader-npm-3.3.4-e2ff5c12be-8f8027fc5c.zip/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../../.yarn/__virtual__/style-loader-virtual-1acf154a53/0/cache/style-loader-npm-3.3.4-e2ff5c12be-8f8027fc5c.zip/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../../.yarn/__virtual__/style-loader-virtual-1acf154a53/0/cache/style-loader-npm-3.3.4-e2ff5c12be-8f8027fc5c.zip/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../../.yarn/__virtual__/style-loader-virtual-1acf154a53/0/cache/style-loader-npm-3.3.4-e2ff5c12be-8f8027fc5c.zip/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../../.yarn/__virtual__/css-loader-virtual-12041de04e/0/cache/css-loader-npm-6.11.0-d945f9f4c0-bb52434138.zip/node_modules/css-loader/dist/cjs.js!./exofont.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../../.yarn/__virtual__/css-loader-virtual-12041de04e/0/cache/css-loader-npm-6.11.0-d945f9f4c0-bb52434138.zip/node_modules/css-loader/dist/cjs.js!./exofont.css";
       export default content && content.locals ? content.locals : undefined;
